import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import SearchPageRoute from './SearchPageRoute';

const basePath = '/v2/search';

export default (
  <Route path={basePath}>
    <MainLayout deprecated>
      <Switch>
        <Route exact path={basePath}>
          <SearchPageRoute />
        </Route>
        <Route>
          <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
        </Route>
      </Switch>
    </MainLayout>
  </Route>
);
